import { DaoService } from "./DaoService";

export class DepartementService extends DaoService {

    static CLASS_NAME = "App\\Models\\Departement";
    
    static getInstance() {
        return super.getInstance('departement');
    }

    enable(idOrUid) {
        return DepartementService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return DepartementService.post(`${this.prefix}/${idOrUid}/disable`);
    }

    all() {
        return DepartementService.get(`${this.prefix}/all`);
    }

    search(data) {
        return DepartementService.post(`${this.prefix}/search`, data);
    }

    syncFromSiRH() {
        return DepartementService.post(`${this.prefix}/sync-from-sirh`);
    }

}
